﻿import { useQuery, useMutation, useQueryClient } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";

import { getOrderClassification, getOrderClassifications, saveOrderClassification, deleteOrderClassification } from "@/api/Maintainers/order_classifications";

const key = "classifications";

export function useOrderClassification(selected) {
	return useQuery([key, selected], () => selected && getOrderClassification({ selected }));
}

export function useOrderClassificationsPaginate(params) {
	return useQuery([key, params], () => getOrderClassifications(params));
}

export function useMutateOrderClassification(params) {
	const navigate = useNavigate();
	const location = useLocation();
	const queryClient = useQueryClient();

	return useMutation(saveOrderClassification, {
		onSuccess: (response) => {
			const classifications = _.omit(response, "detail");
			const classification = _.omit(response, key);

			queryClient.setQueryData([key, String(classification.detail.id)], classification);
			queryClient.setQueryData([key, params], classifications);

			if (params.search) {
				queryClient.invalidateQueries([key]);
			}

			if (location.state) {
				navigate(location.state);
				return;
			}

			navigate("/configuracion/clasificaciones_oc");
		},
	});
}

export function useMutateDeleteOrderClassification(params) {
	const queryClient = useQueryClient();

	return useMutation(deleteOrderClassification, {
		onSuccess: (response) => {
			queryClient.setQueryData([key, params], response);
		},
	});
}
